export const shouldUseSelectivePublicAccountMode = ({
  isSelective = false,
  isPrivilegedUser = false,
} = {}) => Boolean(isSelective && !isPrivilegedUser);

export const isSelectiveAccountEmailVerified = (user) =>
  Boolean(
    user?.email_verified ||
      user?.email_confirmed_at ||
      user?.confirmed_at ||
      user?.raw?.email_confirmed_at ||
      user?.raw?.confirmed_at,
  );
